var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultPage',[_c('HomeHeroVideo'),_c('HomeLetter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }